import React, { useState, useCallback } from 'react';
import { View, Pressable, Text} from 'react-native';
import { UPDATE_ASSET } from './queries';
import { useQuery, useMutation } from '@apollo/client';
import moment from 'moment';

import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { set, useForm } from 'react-hook-form';
import { ButtonContainer } from './elements';
import { Button, ButtonGroup } from 'app/src/elements/buttons';

const EditNotes = ({asset, setShowModal, refetch}) => {
  const [submitting, setSubmitting] = useState();
  const [updateAsset] = useMutation(UPDATE_ASSET, {
    onCompleted: () => {
      setShowModal(false);
      if(refetch) refetch();
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input['year'] = parseInt(input['year']);
    updateAsset({ variables: input });
  });

  const { control, handleSubmit, setValue, reset, resetField, watch, register,
    formState: { errors }
  } = useForm({
    defaultValues: {
      id: asset.id,
      sellerId: asset.seller.id,
      year: asset.year || parseInt(moment().format('YYYY')),
      make: asset.make || '',
      model: asset.model || '',
      vin: asset.vin || '',
      notes: asset.notes || ''
    }
  });
  return (
    <View>
      <Input.TextArea
        label=""
        name="notes"
        rows="20"
        control={control}
        errors={errors}
      />
      <ButtonContainer>
        <ButtonGroup>
          <Button label="Update Notes" onPress={handleSubmit(onSubmit)} />
        </ButtonGroup>
      </ButtonContainer>
    </View>
  )
}

export default EditNotes;
